module.exports = __webpack_public_path__ + "img/result_2.08d8e207.png";